import {
  type DashRouteType,
  URL_PARTNER_SCOPED,
  URL_RETAILER_SCOPED,
  URL_SITE_SCOPED,
} from '@retailer-platform/dashboard/route-patterns'

const URL_CUSTOMERS = `${URL_RETAILER_SCOPED}/customers`
const URL_CUSTOMERS_SITE_SCOPED = `${URL_CUSTOMERS}${URL_SITE_SCOPED}`
const URL_CUSTOMERS_PARTNER_SCOPED = `${URL_PARTNER_SCOPED}/customers`

// Customers -> Search Customers
const URL_CUSTOMERS_SEARCH = `${URL_CUSTOMERS_SITE_SCOPED}/search`
const URL_CUSTOMERS_CUSTOMER_DETAILS = `${URL_CUSTOMERS_SEARCH}/:customerId/details`
const URL_CUSTOMERS_CUSTOMER_PRIVACY_REQUESTS = `${URL_CUSTOMERS_SEARCH}/:customerId/privacy-requests`
const URL_CUSTOMERS_CUSTOMER_ORDER_HISTORY = `${URL_CUSTOMERS_SEARCH}/:customerId/order-history`

// Customers -> Search Customers (partner scoped)
const URL_CUSTOMERS_SEARCH_PARTNER_SCOPED = `${URL_CUSTOMERS_PARTNER_SCOPED}/search`

// Customers -> Privacy Requests (partner scoped)
const URL_CUSTOMERS_PRIVACY_REQUESTS_PARTNER_SCOPED = `${URL_CUSTOMERS_PARTNER_SCOPED}/privacy-requests`

// Customers -> Privacy Requests
const URL_CUSTOMERS_PRIVACY_REQUESTS = `${URL_CUSTOMERS_SITE_SCOPED}/privacy-requests`
// @hygen:inject scoped-urls

export type DashRouteSet =
  | DashRouteType<'customers'>
  | DashRouteType<'customers-search'>
  | DashRouteType<'customers-customer-details'>
  | DashRouteType<'customers-customer-privacy-requests'>
  | DashRouteType<'customers-customer-order-history'>
  | DashRouteType<'customers-privacy-requests'>
  | DashRouteType<'customers-partner-scoped'>
  | DashRouteType<'customers-search-partner-scoped'>
  | DashRouteType<'customers-privacy-requests-partner-scoped'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  customers: URL_CUSTOMERS_SITE_SCOPED,
  'customers-search': URL_CUSTOMERS_SEARCH,
  'customers-privacy-requests': URL_CUSTOMERS_PRIVACY_REQUESTS,
  'customers-customer-details': URL_CUSTOMERS_CUSTOMER_DETAILS,
  'customers-customer-privacy-requests': URL_CUSTOMERS_CUSTOMER_PRIVACY_REQUESTS,
  'customers-customer-order-history': URL_CUSTOMERS_CUSTOMER_ORDER_HISTORY,
  'customers-partner-scoped': URL_CUSTOMERS_PARTNER_SCOPED,
  'customers-search-partner-scoped': URL_CUSTOMERS_SEARCH_PARTNER_SCOPED,
  'customers-privacy-requests-partner-scoped': URL_CUSTOMERS_PRIVACY_REQUESTS_PARTNER_SCOPED,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
